module.exports = __webpack_public_path__ + "img/3.2_Our-Research_Grog-Survey-App_image.ff204db9f7a8bf7a03b9909d0f90e1c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.2_Our-Research_Grog-Survey-App_image.png
// module id = 794
// module chunks = 0